import { ref } from 'vue';
import UsersAPI from '@/api/users';

export function useUsers() {
  const users = ref([]);

  const fetchUsers = async () => {
    const response = await UsersAPI.getAll();

    users.value = response;
  };

  return {
    users,
    fetchUsers
  };
}
